import Trigger from "../../validations/es6/plugins/Trigger";
import Bootstrap from "../../validations/es6/plugins/Bootstrap";
import SubmitButton from "../../validations/es6/plugins/SubmitButton";
import { getValidationMessage } from "../../utils/i18nHelper";

import userDataFormValidationEN from "../../locales/en/userDataFormValidation";
import userDataFormValidationDE from "../../locales/de/userDataFormValidation";
import userDataFormValidationES from "../../locales/es/userDataFormValidation";
import userDataFormValidationFR from "../../locales/fr/userDataFormValidation";
import userDataFormValidationIT from "../../locales/it/userDataFormValidation";
import userDataFormValidationHR from "../../locales/hr/userDataFormValidation";

const euCountryCodes = ["AT", "BE", "BG", "CY", "CZ", "DE", "DK", "EE", "EL", "ES", "FI", "FR", "HR", "HU", "IE", "IT", "LT", "LU", "LV", "MT", "NL", "PL", "PT", "RO", "SE", "SI", "SK", "GB", "GR"];

export const validationMessages = {
  en: userDataFormValidationEN,
  de: userDataFormValidationDE,
  es: userDataFormValidationES,
  fr: userDataFormValidationFR,
  it: userDataFormValidationIT,
  hr: userDataFormValidationHR,
};

export const createValidationOptionsStepOne = (lang) => {
  return {
    fields: {
        firstName: {
            validators: {
                notEmpty: {
                    message: getValidationMessage(validationMessages, 'firstName', 'required', lang)
                },
            }
        },
        lastName: {
            validators: {
                notEmpty: {
                    message: getValidationMessage(validationMessages, 'lastName', 'required', lang)
                },
            }
        },
        personalStreet: {
            validators: {
                notEmpty: {
                    message: getValidationMessage(validationMessages, 'personalStreet', 'required', lang)
                },
            }
        },
        personalZip: {
            validators: {
                notEmpty: {
                    message: getValidationMessage(validationMessages, 'personalZip', 'required', lang)
                },
            }
        },
        personalCity: {
            validators: {
                notEmpty: {
                    message: getValidationMessage(validationMessages, 'personalCity', 'required', lang)
                },
            }
        },
        personalCountry: {
            validators: {
                notEmpty: {
                    message: getValidationMessage(validationMessages, 'personalCountry', 'required', lang)
                },
            }
        },
    },
    plugins: {
        trigger: new Trigger(),
        bootstrap: new Bootstrap(),
        submitButton: new SubmitButton(),
      }
  };
};

export const createValidationOptionsStepTwo = (lang) => {
    return {
      fields: {
        businessType: {
            validators: {
                notEmpty: {
                    message: getValidationMessage(validationMessages, 'businessType', 'required', lang)
                },
            }
        },
        vatNumber: {
            validators: {
                vat: {
                    isSoleProprietor: function() {
                        return document
                        .getElementById("businessInfoForm")
                        .querySelector('[name="isSoleProprietor"]').value === "yes";
                    },
                    isAnEUCountry: function() {
                        let countryCode = document
                        .getElementById("businessInfoForm")
                        .querySelector('[name="countryCode"]').value.toUpperCase();
                        return euCountryCodes.includes(countryCode)
                    },
                    country: function() {
                        let countryCode = document
                        .getElementById("businessInfoForm")
                        .querySelector('[name="countryCode"]').value;
                        return countryCode
                    },
                    message: getValidationMessage(validationMessages, 'vatNumber', 'invalid', lang)
                }
            }
        },
        taxNumber: {
            validators: {
            }
        },
    },
    plugins: {
        trigger: new Trigger(),
        bootstrap: new Bootstrap(),
        submitButton: new SubmitButton(),
    },
  };
};